module.exports = __webpack_public_path__ + "media/images/closed-eye-4e80ea89b91eaac0e43b2dd850934076.png";